import React from "react";
import DefaultButton from "../../components/DefaultButton";

export default function ThankYou(){
    return(
        <>
        <section className="thankyou-area header-gap">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="thankyou-mainbox text-center">
                            <img src="/assets/images/dox-thank-you-envalop.webp" alt="Thankyou Envalop" />
                            <h1 className="heading">Thank You</h1>
                            <span>For reaching out to Dox and Box</span>
                            <p>We value your trust and look forward to serving you again</p>
                            <DefaultButton text={"Go to homepage"} to={"/"} color={true}/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}